import type { AdminRole } from '@/lib/api-admin';

const PICKUP_COMPLETE_ROLES: ReadonlyArray<AdminRole> = [
  'PICKUP_AGENT',
  'OPS_ADMIN',
  'SUPER_ADMIN',
];

export const canConfirmOrderPickup = (roles: ReadonlyArray<AdminRole>): boolean =>
  PICKUP_COMPLETE_ROLES.some((r) => roles.includes(r));
